import { useMutation } from '@tanstack/react-query';
import type { SubmitNativeApplicationRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { SubmitNativeApplication200 } from '@lotushealth/lotushealth_js_sdk/schemas';

import { submitNativeApplicationApi } from '../api/submitNativeApplication.js';
import { clinicianApplicationKeys } from './keys.js';

export interface SubmitNativeApplicationVariables {
  data: SubmitNativeApplicationRequestT;
}

export function useSubmitNativeApplicationMutation() {
  return useMutation<SubmitNativeApplication200, Error, SubmitNativeApplicationVariables>({
    mutationKey: [...clinicianApplicationKeys.all, 'submitNative'],
    mutationFn: async ({ data }) => {
      return await submitNativeApplicationApi(data);
    },
  });
}
